import { useDispatch, useSelector } from 'react-redux';
import GenericLineChart from '../../Charts/GenericLineChart';
import PerformanceCard from '../PerformanceCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceMedianResponseTimeCard } from '@/store/slices/components/dashboard/service';
import getLineChartYStepValue from '../../utils/getLineChartYStepValue';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function ResponseTimeEvolution() {
  const dispatch = useDispatch();
  const { loading, hasFetched, labels, datasets } = useSelector(
    (state) => state.DashboardSlice.medianResponseTime
  );
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceMedianResponseTimeCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'responseTime',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="response-time-evolution"
    >
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'ResponseTimeEvolution')}
      </PerformanceCard.Header>
      <PerformanceCard.Content>
        <GenericLineChart
          labels={labels}
          datasets={datasets}
          yStepSize={getLineChartYStepValue(datasets[0]?.data)}
          yTitle={Trans(translations, 'Hours')}
          autoSkip
          tooltipSuffix="hs"
        />
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}
